export const defaultCustomLayoutValue = () => {
  return {
    objects: [],
    parent_width: 0,
    parent_height: 0,
    allowed_height: 500,
    allowed_width: 800,
  };
};

export const returnNewCLOLayer = () => {
  return {
    type: null,
    picture_type: null,
    picture_library: null,
    clipart: null,
    clipart_tts_text : "",
    layers: [],
    answer: "",
    input_size: "2",
    input_type: null,
    text: "",
    font_size: 24,
    is_bold: false,
    text_align: null,
    answer_not_exactly_same: false,
    hline_color: "#4a4a4a",
    hline_height: 1,
    hline_angle: 0,
    hline_left_end: null,
    hline_right_end: null,
    shape_styles: null,
    multi_layers: null,
    shapes: {
      type: "S",
      rotate_angle: 0,
      shape_styles: null,
      polygon: { sides: 0, show_angles: [] },
      square: { skew_angle: 0, show_angles: [] },
    },
    clock: null,
    shapes_grid: null,
    top: 0,
    left: 0,
    width: 50,
    height: 50,
    sound_box : {
      type : "TTS",
      text_input : ""
    }
  };
};
